import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getFromLocalStorage } from '../utils/storageUtil';

const AdminProtected = () => {
    const admin = getFromLocalStorage('admin');
    return (
        admin ? <Outlet /> : <Navigate to='/auth/login' />
    )
}

export default AdminProtected;